import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Twitter } from "lucide-react";
import { api } from "../lib/api";

const LOGO = "https://customer-assets.emergentagent.com/job_f80e39fa-3ab4-4fff-9ec3-40cb3c2b407a/artifacts/j5jurx70_ChatGPT%20Image%20May%2023%2C%202026%2C%2012_14_44%20PM.png";

const ICONS = [
  { key: "instagram", Icon: Instagram, label: "Instagram" },
  { key: "facebook", Icon: Facebook, label: "Facebook" },
  { key: "youtube", Icon: Youtube, label: "YouTube" },
  { key: "twitter", Icon: Twitter, label: "Twitter / X" },
];

export default function Footer() {
  const [social, setSocial] = useState({});

  useEffect(() => {
    api
      .get("/settings")
      .then((r) => setSocial(r.data?.social || {}))
      .catch(() => {});
  }, []);

  const visible = ICONS.filter((s) => (social[s.key] || "").trim());

  return (
    <footer className="border-t border-[#27272A] bg-black mt-24" data-testid="store-footer">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2">
          <img src={LOGO} alt="Cult Lyf" className="h-16 w-16" />
          <p className="font-display font-black text-2xl mt-4 leading-none">LIVE DIFFERENT.<br/>STAY CULT.</p>
          <p className="label-mono text-[#71717A] mt-4 max-w-xs">Streetwear from the underground. Heavyweight cotton, neon graffiti, limited drops. Est. 2026.</p>
        </div>
        <div>
          <p className="label-mono text-[#71717A] mb-4">Shop</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/shop" className="hover:text-[#CFF048]">All Tees</Link></li>
            <li><Link to="/shop?collection=drop-01" className="hover:text-[#CFF048]">Drop 01</Link></li>
            <li><Link to="/shop?collection=limited" className="hover:text-[#CFF048]">Limited</Link></li>
            <li><Link to="/shop?collection=core" className="hover:text-[#CFF048]">Core</Link></li>
          </ul>
        </div>
        <div>
          <p className="label-mono text-[#71717A] mb-4">Cult</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/orders" className="hover:text-[#CFF048]">Track Order</Link></li>
            <li><Link to="/login" className="hover:text-[#CFF048]">Sign In</Link></li>
            <li><Link to="/privacy" className="hover:text-[#CFF048]" data-testid="footer-privacy">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-[#CFF048]" data-testid="footer-terms">Terms &amp; Conditions</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#27272A]">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="label-mono text-[#71717A]">© 2026 CULT LYF // NOT A TREND. IT&apos;S A LYF.</p>
          <div className="flex gap-4" data-testid="footer-socials">
            {visible.length === 0 ? (
              <span className="label-mono text-[#27272A]">// SOCIALS COMING SOON</span>
            ) : (
              visible.map(({ key, Icon, label }) => (
                <a
                  key={key}
                  href={social[key]}
                  target="_blank"
                  rel="noreferrer noopener"
                  aria-label={label}
                  className="text-[#71717A] hover:text-[#CFF048] transition-colors"
                  data-testid={`footer-social-${key}`}
                >
                  <Icon size={18} />
                </a>
              ))
            )}
          </div>
        </div>
      </div>
    </footer>
  );
}
